export const DATA_COLUMN_MIN_WIDTH = 133;
